import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, Icon, VStack,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, Textarea,
} from '@chakra-ui/react';
import { MdSave } from 'react-icons/md';
import { Form, Field } from 'react-final-form';

function AddEditMedicineModal({ 
    company_id, medicineDetail, actionStatus, initialRef, isOpen, onClose, apiCreateNewMedicine, apiUpdateAMedicine,
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ isProcessing, setIsProcessing ] = useState(false);

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.code) {
            errors.code = "Required";
        }
        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.medicine_group) {
            errors.medicine_group = "Required";
        }

        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        if(medicineDetail && medicineDetail.id) {
            apiUpdateAMedicine({ 
                id: medicineDetail.id, 
                payload: {
                    ...values,
                    user_id: cookies?.loginCookie?.data?.id,  
                }
            });
        } else {
            apiCreateNewMedicine({ 
                ...values,
                user_id: cookies?.loginCookie?.data?.id,   
            });
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="xl">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...medicineDetail
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { medicineDetail && medicineDetail.id ? "CẬP NHẬT" : "TẠO MỚI" }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} mx={2} my={2} justify="space-between" gap={2}>
                                        <VStack justify="flex-start" width="100%">
                                            <Field name="code">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Mã thuốc:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="medicine_group">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Nhóm thuốc:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="price">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Giá bán:</FormLabel>
                                                        <Input {...input} type='number' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="defaultOneDay">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Mặc định mỗi ngày:</FormLabel>
                                                        <Input {...input} type='number' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </VStack>

                                        <VStack justify="flex-start" width="100%">
                                            <Field name="name">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Tên thuốc:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="unit">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Đơn vị tính:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="quantity">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Số lượng:</FormLabel>
                                                        <Input {...input} type='number' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="usage">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Cách dùng:</FormLabel>
                                                        <Textarea {...input} placeholder='' rows={4}/>
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </VStack>
                                    </Flex>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid | pristine}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditMedicineModal;